import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button, DatePicker, Progress, Typography } from 'antd';
import { CheckCircleTwoTone, CloseCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import { useGlobalContext } from '../../App';
import { group_zh } from '../../settings/data-headers';

const { Text } = Typography;

export default () => {
    const {
        runType,
        setRunType,
        STIData,
        STIOrderData,
        fogOrderData,
        STIResult,
        setSTIResult,
        result701,
        setResult701,
        result702,
        setResult702,
        skillDatas,
        regionDatas,
        officeDatas,
        employeeDatas,
        serviceDatas,
        scheduledData,
        dailyData,
        prevOrderData,
        newOrderData,
        staffResult,
        setStaffResult,
        perStaffScheduledResult,
        setPerStaffScheduledResult,
        allStaffScheduledResult,
        setAllStaffScheduledResult,
        prevOrderResult,
        setPrevOrderResult,
        newOrderResult,
        setNewOrderResult,
        otherOrderResult,
        setOtherOrderResult,
    } = useGlobalContext();
    
    const resOrder = newOrderData.filter((order) => { return order.orderType === '餐飲客' });
    const nonresOrder = newOrderData.filter((order) => { return order.orderType === '非餐飲客' });
    
    const [selectedDate, setSelectedDate] = useState('');
    const [dateDisable, setDateDisable] = useState(false);  //日期选择框在执行算法时不可用

    const [buttonDisable, setButtonDisable] = useState(true);   //运行按钮未选择日期或loading时不可用
    const [loading, setLoading] = useState(false);  //运行按钮loading状态

    const [percent, setPercent] = useState(0);
    const [status, setStatus] = useState(false);    //true：已获运行结果信息
    const [progressMsg, setProgressMsg] = useState('');
    const [successDone, setSuccessDone] = useState(false);
    
    useInterval(() => {
        if (percent <= 90) {
            setPercent((percent) => (percent + Math.floor(Math.random()*10+1)));
        }
    }, loading ? 1500 : null);

    const runSchedule = useCallback(async () => {

        // 日期选择框置灰，初始化进度条及返回信息
        setDateDisable(true);
        setProgressMsg('');
        setStatus(false);
        setLoading(true);
        setPercent(0);
        
        //员工数据格式处理
        const staffs = employeeDatas.map((employee) => {
            let staff = { ...employee };
            staff.ID = employee.ID;
            staff.name = employee.name;
            let skills = [];
            for (let i = 1; i < 15; i++) {
                if (employee['skill_' + i] === 'Y') {
                    skills.push(i);
                }
                staff.skills = skills.join(',');
            }
            let group = [];
            for (let j = 1; j < 7; j++) {
                if (employee['group_' + j]) {
                    group.push(group_zh[j - 1]);
                }
                staff.group = group.join(',');
            }
            if (employee['capacity']) {
                staff.capacity = parseInt(employee['capacity']);
            } else {
                staff.capacity = 4;
            }
            return staff;
        });

        // java算法请求
        let params;
        if (runType === 'normal') {
            scheduledData.forEach((element) => {
                return element.blacklist = '';
            });

            params = {
                "staff_data": staffs,// args[0]员工信息 必要property:[{ID:'',name:'',skills:'',group:'',capacity:''}]
                "skill_data": skillDatas,// args[1]技能数据 必要property:[{id:'', name:''}]
                "service_data": serviceDatas,// args[2]服务数据 必要property:[{type:'',customer_ID:'',skills:'',people:''}]
                "region_data": regionDatas,// args[3]分区数据
                "office_data": officeDatas,//办公室与大区关系数据
                "scheduled_data": scheduledData,// args[4]6月外勤同事進度表
                "daily_data": dailyData,// args[5]本月每日工作单
                "prevOrder_data": prevOrderData,// args[6]舊單重排
                "resOrder_data": resOrder,// args[7]餐飲新訂單
                "nonresOrder_data": nonresOrder,// args[8]非餐饮新訂單
                "selected_date": selectedDate,// args[9]排班日期
            };
        } else {
            // STI排班
            STIData.forEach((element) => {
                return element.blacklist = '';
            });

            params = {
                "staff_data": staffs,// args[0]员工信息 必要property:[{ID:'',name:'',skills:'',group:'',capacity:''}]
                "skill_data": skillDatas,// args[1]技能数据 必要property:[{id:'', name:''}]
                "service_data": serviceDatas,// args[2]服务数据 必要property:[{type:'',customer_ID:'',skills:'',people:''}]
                "region_data": regionDatas,// args[3]分区数据
                "office_data": officeDatas,//办公室与大区关系数据
                "STI_data": STIData,// args[4]全部工作单
                "STIOrder_data": STIOrderData,// // args[5]STI服务
                "fogOrder_data": fogOrderData,// // args[6]焗霧服務
                "selected_date": selectedDate,// args[7]排班日期
            };
        }
        
        const res = await (
            await fetch('/api/runScheduling', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(params),
            })
        ).json();

        console.log(res)

        setProgressMsg('運行中...');

        if (res.code === 200) {
            setSuccessDone(true);
            if (runType === 'normal') {
                // 全部員工數據
                let staffResults = [];
                if (Object.keys(res.data).length !== 0 && res.data['员工数据']) {
                    staffResults = res.data['员工数据'].map((uuid) => {
                        const staff = employeeDatas.find((employee) => employee.ID === uuid.id) || {};
                        const staffInit = Object.assign(staff, uuid);
                        staffInit.can_receive_order = staffInit.can_receive_order.toString();
                        return staffInit;
                    });
                }
                setStaffResult(staffResults);

                // 單個員工
                let perResults = [];
                if (Object.keys(res.data).length !== 0 && res.data['个人排班']) {
                    perResults = res.data['个人排班'].map((per) => {
                        per.data_list.forEach((list, index) => {
                            list.key = index;
                            return list;
                        });
                        return per;
                    });
                }
                setPerStaffScheduledResult(perResults);

                // 全體排班（更新的外勤同事進度表）
                let allResults = [];
                if (Object.keys(res.data).length !== 0 && res.data['全体排班']) {
                    allResults = res.data['全体排班'].map((all, index) => {
                        const init = { ...scheduledData.find((sche) => sche.order_ID === all.order_ID) };
                        const all_init = Object.assign(init, all);
                        return all_init;
                    });
                }
                setAllStaffScheduledResult(allResults);

                // 舊單重排   
                // 对这段代码的理解：从 prevOrderData 的 order_ID中 找出 和 接口排完的 order_ID 相同的 单子 ，然后合并以接口排的为准
                let prevResults = [];
                if (Object.keys(res.data).length !== 0 && res.data['旧单重排']) {
                    prevResults = res.data['旧单重排'].map((prev, index) => {
                        const prevInit = prevOrderData.find((order) => order.order_ID === prev.order_ID) || {};
                        const prev_init = Object.assign(prevInit, prev);
                        return prev_init;
                    });
                }
                setPrevOrderResult(prevResults);

                // 新餐飲
                let newResults = [];
                if (Object.keys(res.data).length !== 0 && res.data['新餐饮订单']) {
                    newResults = res.data['新餐饮订单'].map((res, index) => {
                        const newInit = resOrder.find((order) => order.order_ID === res.order_ID) || {};
                        const new_init = Object.assign(newInit, res);
                        return new_init;
                    });
                }
                setNewOrderResult(newResults);

                // 新非餐飲
                let nonResults = [];
                if (Object.keys(res.data).length !== 0 && res.data['新非餐饮订单']) {
                    nonResults = res.data['新非餐饮订单'].map((tmp, index) => {
                        const otherInit = nonresOrder.find((other) => (other.order_ID === tmp.order_ID)) || {};
                        const other_init = Object.assign(otherInit, tmp);
                        return other_init;
                    });
                }
                setOtherOrderResult(nonResults);
            } else {
                // STI排班結果
                // const stiResults = res.data['STI排班'];
                let stiResults = [];
                if (Object.keys(res.data).length !== 0 && res.data['STI排班']) {
                    stiResults = res.data['STI排班'].map((sti,index) => {
                        sti.key = index;
                        return sti;
                    });
                }
                setSTIResult(stiResults);

                //T701 STI
                let result_701 =[];
                if (Object.keys(res.data).length !== 0 && res.data['701排班']) {
                    result_701 = res.data['701排班'].map((s,index) => {
                        s.key = index;
                        return s;
                    });
                }
                setResult701(result_701);


                //T702 FOG
                let result_702 =[];
                if (Object.keys(res.data).length !== 0 && res.data['702排班']) {
                    result_702 = res.data['702排班'].map((fog,index) => {
                        fog.key = index;
                        return fog;
                    });
                }
                setResult702(result_702);
            }

            setProgressMsg('運行成功！在左側“結果”部分可以查看和保存排程結果');
            setPercent(100);
            setStatus(true);
            setLoading(false);
            setDateDisable(false);
            return;
        } else {
            console.log('卡这里了')
            setSuccessDone(false);
            setProgressMsg(res.msg);
            setStatus(true);
            setLoading(false);
            setDateDisable(false);
            return;
        }
    });

    const onChange = (date, dateString) => {
        console.log(dateString);
        setSelectedDate(dateString);
        setButtonDisable(dateString === '');
        // 在运行过一次出现返回信息的基础上切换日期重跑时，重置页面信息
        if(status){
            setStatus(false);
            setProgressMsg('');
        }
    };
    
    return (
        <div style={{ padding: '16px 0px' }}>
            <div>
                <label>排班日期：</label>
                <DatePicker onChange={onChange} disabled={dateDisable}/>
            </div>
            <div style={{ marginTop: 16 }}>
                <label>运行排班：</label>
                <Button type="default" disabled={buttonDisable} loading={loading} onClick={runSchedule}>Run Schedule</Button>
            </div>

            {loading && (
                <div style={{ marginTop: 32, textAlign: 'center' }}>
                    <div className='desc' >
                        <Text><LoadingOutlined style={{ marginRight: '5px' }} />{progressMsg}</Text>
                    </div>
                    <Progress percent={percent} />
                </div>
            )}

            {status && (
                <div className='desc' style={{ marginTop: 32, textAlign: 'center' }}>
                    {successDone && (<Text><CheckCircleTwoTone twoToneColor="#52c41a" style={{ marginRight: '5px' }} />{progressMsg}</Text>)}
                    {!successDone && (<Text><CloseCircleOutlined style={{ color:'#ff0000', marginRight: '5px' }} />{progressMsg}</Text>)}
                </div>
            )}
        </div>
    );
};

export function useInterval(callback, delay) {
    const savedCallback = useRef();

    useEffect(() => {
        savedCallback.current = callback;
    });

    useEffect(() => {
        function tick() {
            savedCallback.current();
        }

        if (delay !== null) {
            let id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay]);
} 